import React from 'react';

// "Session X/N" per Abo client — 9/N amber ⚠, last session red (Abo-Ende).
export const AboSessionBadges = ({ sessions, className = '', size = 'xs', testPrefix = 'abo-session' }) => {
  if (!sessions || sessions.length === 0) return null;
  const multi = sessions.length > 1;
  return (
    <div className={`flex flex-wrap gap-0.5 pointer-events-none ${className}`}>
      {sessions.map(s => {
        const last = s.total && s.index >= s.total;
        const warn = s.total && s.index === s.total - 1;
        const normal = size === 'xs' ? 'bg-white/85 text-slate-800' : 'bg-slate-100 text-slate-800 border border-slate-300';
        const cls = last ? 'bg-red-600 text-white' : warn ? 'bg-amber-400 text-amber-950' : normal;
        const first = (s.client_name || '').split(' ')[0];
        const label = `${multi ? `${first} ` : ''}${s.index}${s.total ? `/${s.total}` : ''}${warn ? ' ⚠' : ''}${last ? ' (Abo-Ende)' : ''}`;
        return (
          <span key={s.client_id} title={`Session ${s.index}${s.total ? `/${s.total}` : ''} – ${s.client_name || ''}`}
            className={`${size === 'xs' ? 'text-[8px] px-1 py-[1px]' : 'text-xs px-2 py-0.5'} font-extrabold rounded leading-none whitespace-nowrap ${cls}`}
            data-testid={`${testPrefix}-${s.client_id}`}>
            {size === 'xs' ? label : `Session ${label}`}
          </span>
        );
      })}
    </div>
  );
};

export default AboSessionBadges;
